/**
 * Polyfills Index
 */

import 'babel-polyfill';

import numberIsInteger from './number-is-integer';
numberIsInteger();


// WEBPACK FOOTER //
// ./project/client/src/core/polyfills/index.js